import z from "zod"

export const salesStatusValues = ["AVAILABLE", "ONLINE_ORDERED", "RESERVED", "SOLD", "OPEN_CAMPAIGNS"] as const
export const salesStatusSchema = z.enum(salesStatusValues)
export type SalesStatus = z.infer<typeof salesStatusSchema>
